<mat-button-toggle-group  class="button_toggle_filter_container" [value]="initialValue"  (change)="onChange('Type',$event.value,coverageType)">
  <mat-button-toggle class="button_toggle_filter_button" *ngIf="initialValue && enableAllFilter" [value]="initialValue">
    <adp-label labelKey="Global_DeviceCategories_All"></adp-label>
  </mat-button-toggle> 
  <mat-button-toggle   class="icon-div button_toggle_filter_button" *ngFor='let itemType of deviceTypeToggle;' value={{itemType.TableProperty?itemType.TableProperty:itemType.Key}}>
        <img *ngIf="itemType.counter" [src]="itemType.counter" alt="Care plus" />
        <span> {{itemType.Value}}</span>
    </mat-button-toggle>
</mat-button-toggle-group> 
 